var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17851 23.6785C3.52764 23.0276 3.52764 21.9724 4.17851 21.3215L19.4992 6.00084C20.15 5.34997 21.2053 5.34997 21.8562 6.00084L25.3917 9.53636C24.4154 10.5127 24.4154 12.0956 25.3917 13.0719C26.368 14.0482 27.9509 14.0482 28.9272 13.0719L32.4628 16.6074C33.1137 17.2583 33.1137 18.3136 32.4628 18.9645L17.1421 34.2851C16.4913 34.936 15.436 34.936 14.7851 34.2851L11.2496 30.7496C12.2259 29.7733 12.2259 28.1904 11.2496 27.2141C10.2733 26.2378 8.69037 26.2378 7.71406 27.2141L4.17851 23.6785Z",
    fill: "#D1CFCD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1451_18308",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 30,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17851 23.6785C3.52764 23.0276 3.52764 21.9724 4.17851 21.3215L19.4992 6.00084C20.15 5.34997 21.2053 5.34997 21.8562 6.00084L25.3917 9.53636C24.4154 10.5127 24.4154 12.0956 25.3917 13.0719C26.368 14.0482 27.9509 14.0482 28.9272 13.0719L32.4628 16.6074C33.1137 17.2583 33.1137 18.3136 32.4628 18.9645L17.1421 34.2851C16.4913 34.936 15.436 34.936 14.7851 34.2851L11.2496 30.7496C12.2259 29.7733 12.2259 28.1904 11.2496 27.2141C10.2733 26.2378 8.69037 26.2378 7.71406 27.2141L4.17851 23.6785Z",
    fill: "url(#paint0_linear_1451_18308)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1451_18308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.82153,
    y: 23.6785,
    width: 8.33333,
    height: 18.3333,
    transform: "rotate(-45 1.82153 23.6785)",
    fill: "#FF791C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1451_18308",
    x1: 11.676,
    y1: 17.9178,
    x2: 24.9402,
    y2: 19.8026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F75C3B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuTicket);
export default __webpack_public_path__ + "static/media/wikiMenuTicket.6add69565f43d0966d7af30f15bb60f9.svg";
export { ForwardRef as ReactComponent };